// extracted by mini-css-extract-plugin
module.exports = {"icon":"ChevronArrow_icon__2i9zj","closedIcon":"ChevronArrow_closedIcon__1htv_"};